import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  if (localStorage.getItem("userInfo") && (localStorage.getItem("userInfo") !== null) && localStorage.getItem("userInfo").length) {
    next();
    return;
  }
  next('/login');
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/Home",
      // redirect: "/auth/login",
      component: () => import("./layouts/frontend/Home.vue"),
      children: [
        {
          path: "/Home",
          name: "frontend",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/Home.vue")
        }
      ]
    },
    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/dashboard/Dashboard.vue")
        },
        {
          path: "/folders",
          name: "folders",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/folders/folder.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Dossiers" },
              { title: "Tous", url: '/folders', active: true }
            ],
            pageTitle: "Tous les dossiers",
            rule: 'editor'
          }
        },
        {
          path: "/archives",
          name: "archives",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/archives/index.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Archives" },
              { title: "Tous", url: '/archives', active: true }
            ],
            pageTitle: "Toutes les archives",
            rule: 'editor'
          }
        },
        {
          path: "/third-party",
          name: "thirdparty",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/thirdparty/thirdparty.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Third Party" },
              { title: "Tous", url: '/third-party', active: true }
            ],
            pageTitle: "Tous les Third Party",
            rule: 'editor'
          }
        },
        {
          path: "/folders/requests/:id/details",
          name: "folders_details",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/folders/detail.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Dossiers", url: '/folders' },
              { title: "Toutes les requêtes du dossier", active: true }
            ],
            pageTitle: "Dossier",
            rule: 'editor'
          }
        },
        {
          path: "/requests/assign",
          name: "requests_assign",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/me.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Demandes" },
              { title: "Tous", url: '/requests', active: true }
            ],
            pageTitle: "Mes requêtes",
            rule: 'editor'
          }
        },
        {
          path: "/requests",
          name: "requests",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/Requests.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Demandes" },
              { title: "Tous", url: '/requests', active: true }
            ],
            pageTitle: "Toutes les demandes",
            rule: 'editor'
          }
        },
        {
          path: "/requests/fencing",
          name: "fencing-requests",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/FencingRequests"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Toutes mes demandes", url: "/requests" },
              { title: "Clôturées", url: '/requests/fencing', active: true }
            ],
            pageTitle: "Demandes Clôturées",
            rule: 'editor'
          }
        },
        {
          path: "/requests/mail",
          name: "mail-requests",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/mailRequest/MailRequests"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Toutes mes demandes", url: "/requests" },
              { title: "Mail", url: '/requests/mail', active: true }
            ],
            pageTitle: "Demandes par mail",
            rule: 'editor'
          }
        },
        {
          path: "/requests/pending",
          name: "pending-requests",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/PendingRequests"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Toutes mes demandes", url: "/requests" },
              { title: "En cours", url: '/requests/pending', active: true }
            ],
            pageTitle: "Demandes en cours de traitement",
            rule: 'editor'
          }
        },
        {
          path: "/requests/not-approved",
          name: "not-approved-requests",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/NotApprovedRequests"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Toutes les demandes", url: "/requests" },
              { title: "En attente d'apporbation", url: '/requests/not-approved', active: true }
            ],
            pageTitle: "Demandes en attente d'approbation",
            rule: 'editor'
          }
        },
        {
          path: "/requests/:id/detail/:event",
          name: "single-request",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/SingleRequest.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Toutes mes demandes", url: "/requests" },
              { title: "Demande", url: '/requests/:id', active: true }
            ],
            pageTitle: "Demande",
            rule: 'editor'
          }
        },
        {
          path: '/chat',
          name: 'chat',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/chat/Chat.vue'),
          meta: {
            no_scroll: true,
          }
        },
        {
          path: '/profile',
          name: 'profile',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/profile/Profile'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Profil", url: '/profile', active: true }
            ],
            pageTitle: "Mon profil",
            rule: 'editor'
          }
        },
        {
          path: '/invoices/:id/detail',
          name: 'Factures',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/invoices/Invoices'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Factures", url: '/invoices', active: true }
            ],
            pageTitle: "Liste des factures",
            rule: 'editor'
          }
        },
        {
          path: '/invoices',
          name: 'bills',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/invoices/bills'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Factures", url: '/invoices', active: true }
            ],
            pageTitle: "Liste des factures",
            rule: 'editor'
          }
        },
        {
          path: '/bills/:id/payment',
          name: 'bill_payment',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/invoices/payment'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Reglement", url: '/payments', active: true }
            ],
            pageTitle: "Liste des réglements de la facture",
            rule: 'editor'
          }
        },
        {
          path: '/uploads/invoices',
          name: 'FacturesUpload',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/invoices/uploads/InvoiceUpload'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Uploads", url: '/uploads/invoices', active: true }
            ],
            pageTitle: "Uploader des factures",
            rule: 'editor'
          }
        },
        {
          path: '/uploads/invoices/:id/results',
          name: 'ResultsInvoiceUpload',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/invoices/uploads/InvoiceResult'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Uploads", url: "/" },
              { title: "Résultats", url: '/uploads/invoices/results', active: true }
            ],
            pageTitle: "Resultats de l'uploads",
            rule: 'editor'
          }
        },
        {
          path: '/uploads/payments',
          name: 'reglementUpload',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/reglement/uploadList'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Upload", url: '/uploads/payments', active: true }
            ],
            pageTitle: "Uploader les réglements",
            rule: 'editor'
          }
        },
        {
          path: '/uploads/payments/:id/results',
          name: 'ResultsPaymentUpload',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/reglement/InvoiceResult'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Uploads", url: "/" },
              { title: "Résultats", url: '/uploads/invoices/results', active: true }
            ],
            pageTitle: "Resultats de l'uploads",
            rule: 'editor'
          }
        },
        {
          path: '/payments/:id/detail',
          name: 'Payments',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/reglement/payment'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Reglement", url: '/payments', active: true }
            ],
            pageTitle: "Liste des réglements",
            rule: 'editor'
          }
        },
        {
          path: '/clients',
          name: 'clients',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/clients/Clients'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Clients", url: '/clients', active: true }
            ],
            pageTitle: "Clients",
            rule: 'editor'
          }
        },
        {
          path: '/clients/import-history/:id',
          name: 'clients_import_history',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/clients/historyImport'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Clients", url: '/clients', active: false },
              { title: "Historique d'importation", url: '/clients', active: true }
            ],
            pageTitle: "Historique d'importation de clients",
            rule: 'editor'
          }
        },
        {
          path: '/clients/:id',
          name: 'clients-details',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/clients/ClientDetails'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Tous les Clients", url: "/clients" },
              { title: "e-Business Afrique", url: '/clients/:id', active: true }
            ],
            pageTitle: "Client e-Business Afrique",
            rule: 'editor'
          }
        },
        {
          path: '/services',
          name: 'services',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/services/Services'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Services", url: '/services', active: true }
            ],
            pageTitle: "Services",
            rule: 'editor'
          }
        },
        {
          path: '/segments',
          name: 'segments',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/segments/Segments'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Segments", url: '/segments', active: true }
            ],
            pageTitle: "Segments",
            rule: 'editor'
          }
        },
        {
          path: '/approbations',
          name: 'approbations',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/approbations/Approbations'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Chaînes d'approbations", url: '/approbations', active: true }
            ],
            pageTitle: "Chaînes d'approbations",
            rule: 'editor'
          }
        },
        {
          path: '/categories',
          name: 'categories',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/categories/Categories'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Type de demandes", url: '/categories', active: true }
            ],
            pageTitle: "Type de demandes",
            rule: 'editor'
          }
        },
        {
          path: '/types',
          name: 'types',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/types/Types'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Sous type de demandes", url: '/types', active: true }
            ],
            pageTitle: "Sous type de demandes",
            rule: 'editor'
          }
        },
        {
          path: '/users',
          name: 'users',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/users/Users'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Utilisateurs", url: '/users', active: true }
            ],
            pageTitle: "Utilisateurs",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/manager',
          name: 'stat_manager',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/manager/manager'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '/users', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/request',
          name: 'stat_req',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/requestStat'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '/users', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/customer',
          name: 'stat_customer',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/customer/customer'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques client", url: '/users', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cc',
          name: 'stat_cc',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cc/cc'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques chargé clientelle", url: '/users', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/ebu',
          name: 'stat_ebu',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques EBU", url: '/statistics/ebu', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/folder',
          name: 'stat_folder',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/folder'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '/statistics/folder', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex',
          name: 'stat_cex',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex/request-realtime-period',
          name: 'stat_cex_realtime_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex/requestRealtimePeriod'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex'},
              { title: "Requêtes à temps réel par période", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex/agent-with-realtime',
          name: 'stat_cex_agent_with_realtime',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex/agentWithRealTime'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex'},
              { title: "Agents à temps réel par période", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex/plainte-period',
          name: 'stat_cex_plainte_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex/plainteWithPeriod'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex'},
              { title: "Total plaintes par période", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex/request-call-reason-period',
          name: 'stat_cex_call_reason',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex/callReason'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex'},
              { title: "Call reason par période", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex/request-canal',
          name: 'stat_cex_request_canal',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex/requestCanal'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex'},
              { title: "Plainte reçu par mail et par ccmt", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex/approbation',
          name: 'stat_cex_request_approbation',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex/approbation'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex'},
              { title: "Approbation par période", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex/sla-category-period',
          name: 'stat_cex_sla_category_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex/sla'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex'},
              { title: "Sla par catégorie et par période", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/ebu/service-period',
          name: 'stat_ebu_service_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/servicePeriod'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques EBU", url: '/statistics/ebu'},
              { title: "Reporting par service et par periode", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/ebu/garphe-nature-period',
          name: 'stat_ebu_nature_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/grapheNature'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques EBU", url: '/statistics/ebu'},
              { title: "Graphe des requêtes par nature et sur une période défini", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/ebu/total-request',
          name: 'stat_ebu_total_request',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/totalRequest'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques EBU", url: '/statistics/ebu'},
              { title: "Total des demandes", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/ebu/history',
          name: 'stat_ebu_history',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/history'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques EBU", url: '/statistics/ebu'},
              { title: "Historique des requêts par clients et par période", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/ebu/history-by-group',
          name: 'stat_ebu_history_by_group',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/totalByGroup'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques EBU", url: '/statistics/ebu'},
              { title: "Plainte reçue par mail et par CCMT par période", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: '/statistics/ebu/call-reason-period',
          name: 'stat_ebu_call_reason_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/callReason'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques EBU", url: '/statistics/ebu'},
              { title: "Call reason par période", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: '/statistics/ebu/sla-category-period',
          name: 'stat_ebu_sla_category_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/slaCategoryPeriod'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques EBU", url: '/statistics/ebu'},
              { title: "SLA par catégorie et par période", url: '#', active: true}
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
      ]
    },
    {
      path: "",
      component: () => import("./layouts/full-page/FullPage.vue"),
      children: [
        {
          path: "/login",
          name: "login",
          component: () => import("./views/auth/Login.vue")
        },
        {
          path: "/password-reset",
          name: "password",
          component: () => import("./views/auth/ForgotPassword.vue")
        }
      ]
    }
  ]
});


export default router
